import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import surveyEditerReducer from "./Store/reducers/surveyEditer";
import tabReducer from "./Store/reducers/Tab";
import authReducer from "./Store/reducers/authentication";
import surveysReducer from "./Store/reducers/surveys";
import surveyReducer from "./Store/reducers/survey";
import dataReducer from "./Store/reducers/data";
import companiesReducer from "./Store/reducers/companies";
import usersReducer from "./Store/reducers/users";
import logsReducer from "./Store/reducers/logs";
import mailAuditReducer from "./Store/reducers/mailAudit";
import "./firebase-config";

if (process.env.NODE_ENV !== "development") console.log = () => {}; // to remove console logs in production

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  surveyEditer: surveyEditerReducer,
  tab: tabReducer,
  auth: authReducer,
  surveys: surveysReducer,
  survey: surveyReducer,
  data: dataReducer,
  companies: companiesReducer,
  users: usersReducer,
  logs: logsReducer,
  mailAudit: mailAuditReducer,
});

const store = createStore(
  rootReducer,
  // composeEnhancers(applyMiddleware(thunk, createLogger({ collapsed: true })))
  composeEnhancers(applyMiddleware(thunk))
);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
